// Put your application javascript here
// 公告栏
var mySwiper = new Swiper('#promobar .swiper', {
  loop: true, // 循环模式选项
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
})

var mySwiper = new Swiper('[data-comp="image-tiles"] .swiper', {
  slidesPerView: 2.1,
  spaceBetween: 20,
  breakpoints: {
    1490: {
      slidesPerView: 5.1,
      spaceBetween: 12
    },
    1080: {
      slidesPerView: 5.1,
      spaceBetween: 12
    },
    789: {
      slidesPerView: 3.1,
      spaceBetween: 20
    }
  }
})
var mySwiper = new Swiper('[data-comp="certification-slider"] .swiper', {
  slidesPerView: 3.5,
  spaceBetween: 38,
  breakpoints: {
    1080: {
      slidesPerView: 9,
      spaceBetween: 0
    },
    789: {
      slidesPerView: 6.5,
      spaceBetween: 25
    }
  }
})

var mySwiper = new Swiper('[data-comp="reviews-slider"] .swiper', {
  loop: true, // 循环模式选项
  slidesPerView: 1.2,
  centeredSlides: true,
  spaceBetween: 20,
  // 如果需要分页器
  pagination: {
    el: '.swiper-pagination',
  },

  // 如果需要前进后退按钮
  navigation: {
    nextEl: '.nextEl',
    prevEl: '.prevE',
  }
})



